module.exports = __webpack_public_path__ + "static/media/misc-actually-pretty-badass.c983308e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/misc-actually-pretty-badass.svg
// module id = 383
// module chunks = 0